import * as moment from "moment-timezone";
import { useEffect, useState } from "react";
import TimezonePicker from "react-timezone";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import { SCButtonAddInput } from "../../components/Buttons/styles";
import classIcon from "../../assets/images/icons/icon_democlasses_header.svg";
import InputForCountry from "../../components/elements/NewInputs/InputForCountry";
import InputForLingoPlan from "../../components/elements/NewInputs/InputForLingoPlan";
import InputForClassTool from "../../components/elements/NewInputs/InputForClassTool";
import InputForLingoArray from "../../components/elements/NewInputs/InputForLingoArray";
import { editDemoClass, getGlobalLanguages, postDemoClass } from "../../store/middleware";

import { Demos } from "./styles";

function DemoClass() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { demoClass } = useSelector((state) => state.genericReducer);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [planId, setPlanId] = useState("");
  const [address, setAddress] = useState("");
  const [timezone, setTimezone] = useState("");
  const [demoType, setDemoType] = useState("");
  const [occupation, setOccupation] = useState("");
  const [alerttitle, setAlertTitle] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [classToolId, setClassToolId] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [globallanguages, setGlobalLanguages] = useState([]);
  const [classConverted, setClassConverted] = useState(false);
  const [nativeLanguageId, setLanguageNativeId] = useState("");
  const [alertdescription, setAlertDescription] = useState("");
  const [classConvertedEmail, setClassConvertedEmail] = useState("");
  const [classTool, setClassTool] = useState({ value: "", required: true });
  const [countryId, setCountryId] = useState({ value: "", required: true });
  const [commercialResponsibleName, setCommercialResponsibleName] = useState("");
  const [demoClassPhones, setDemoClassPhones] = useState([{ phone: "", userPhoneTypeId: "" }]);
  const [demoClassSchedules, setDemoClassSchedules] = useState([
    {
      disabledEdit: null,
      lingoLanguageId: "",
      status: "pending",
      scheduledDate: moment().format("YYYY-MM-DD"),
      scheduledStart: "",
      scheduledEnd: "",
      teacherId: "",
      levelByStudent: "1",
      levelByLingo: "",
      affiliateId: "",
      affiliateName: "",
      affiliateSlug: "",
    },
  ]);

  const loadInfos = () => {
    dispatch(getGlobalLanguages()).then((res) =>
      setGlobalLanguages(res.map((item) => ({ ...item, name: decryptIfEncrypted(item.name) }))),
    );

    if (demoClass && demoClass.length > 0) {
      setName(decryptIfEncrypted(demoClass[0]?.name));
      setEmail(decryptIfEncrypted(demoClass[0]?.email));
      setAddress(decryptIfEncrypted(demoClass[0]?.address));
      setPlanId(demoClass[0]?.planId);
      setTimezone(demoClass[0]?.timezone);
      setDemoType(demoClass[0]?.demoType);
      setOccupation(demoClass[0]?.occupation);
      setClassToolId(demoClass[0]?.classToolId);
      setCompanyName(demoClass[0]?.companyName);
      setClassConverted(demoClass[0]?.classConverted);
      setLanguageNativeId(demoClass[0]?.nativeLanguageId);
      setClassConvertedEmail(demoClass[0]?.classConvertedEmail);
      setClassTool({ value: demoClass[0]?.classTool, required: true });
      setCountryId({ value: demoClass[0]?.countryId, required: true });
      setCommercialResponsibleName(demoClass[0]?.commercialResponsibleName);
      setDemoClassPhones(
        demoClass[0]?.demoClassPhones.map(({ phone, userPhoneTypeId }) => {
          return { phone: decryptIfEncrypted(phone), userPhoneTypeId: userPhoneTypeId };
        }),
      );
      setDemoClassSchedules(
        demoClass[0]?.demoClassSchedules.map(
          ({
            status,
            teacher,
            affiliate,
            scheduledDate,
            lingoLanguageId,
            scheduledStartTime,
            originalScheduledDateTimeUTC,
            container: { levelByStudent, levelByLingo },
          }) => {
            return {
              levelByLingo: levelByLingo,
              scheduledDate: scheduledDate,
              levelByStudent: levelByStudent,
              lingoLanguageId: lingoLanguageId,
              scheduledStart: scheduledStartTime,
              teacherId: teacher ? teacher.id : "",
              status: status === "cancelled" ? "canceled" : status,
              disabledEdit: moment.utc().isAfter(moment(originalScheduledDateTimeUTC).utc()) ? true : false,

              affiliateId: affiliate?.userId,
              affiliateSlug: affiliate?.slug,
              affiliateName: affiliate?.user.name,
            };
          },
        ),
      );
    }
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  const handleChange = (e) => {
    const { target } = e;

    if (target?.name) {
      switch (target?.name) {
        case "commercialResponsibleName":
          setCommercialResponsibleName(target.value);
          break;
        case "name":
          setName(target.value);
          break;
        case "nativeLanguageId":
          setLanguageNativeId(target.value);
          break;
        case "demoType":
          setDemoType(target.value);
          break;
        case "email":
          setEmail(target.value);
          break;
        case "classTool":
          setClassTool({ value: target.value, required: true });
          break;
        case "classToolId":
          setClassToolId(target.value);
          break;
        case "companyName":
          setCompanyName(target.value);
          break;
        case "occupation":
          setOccupation(target.value);
          break;
        case "countryId":
          setCountryId({ value: target.value, required: true });
          break;
        case "address":
          setAddress(target.value);
          break;
        case "classConverted":
          setClassConverted(target.checked);
          break;
        case "classConvertedEmail":
          setClassConvertedEmail(target.value);
          break;
        default:
          break;
      }
    } else {
      if (e.name === "planId") {
        setPlanId(e.value);
      }
    }
  };

  const childInputChange = (data, index) => {
    const { id, value } = data;

    setDemoClassSchedules((state) => state.map((item, i) => (i === index ? { ...item, [id]: value } : item)));
  };

  const addField = (e, newItem) => {
    e.preventDefault();
    setDemoClassSchedules((state) => [...state, newItem]);
  };

  const removeField = (e, findIndex) => {
    e.preventDefault();
    setDemoClassSchedules(demoClassSchedules.filter((value, index) => index !== findIndex));
  };

  let dataNew = moment(new Date()).utc().tz(timezone);

  moment.utc().tz(timezone);

  let dataTimeZone = moment(dataNew).format("LT");

  const validateForm = () => {
    for (let index = 0; index < demoClassSchedules.length; index++) {
      const element = demoClassSchedules[index];

      if (element.disabledEdit === null) {
        if (
          moment(element.scheduledDate + "T" + element.scheduledStart).isBefore(
            moment(dataNew).format("YYYY-MM-DD HH:mm:ss"),
          )
        ) {
          setOpenAlert(true);
          setAlertTitle(t("INVALID_FORM_TITLE"));
          setAlertDescription(t("VALIDATE_SCHEDULE_DATE_PAST"));

          return false;
        }

        if (
          moment(element.scheduledDate + "T" + element.scheduledStart).isBefore(
            moment(dataNew).format("YYYY-MM-DD HH:mm:ss"),
          ) &&
          element.disabledEdit === null
        ) {
          setOpenAlert(true);
          setAlertTitle(t("INVALID_FORM_TITLE"));
          setAlertDescription(t("VALIDATE_SCHEDULE_DATE_PAST"));

          return false;
        }

        if (element.scheduledDate === "") {
          setOpenAlert(true);
          setAlertTitle(t("INVALID_FORM_TITLE"));
          setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("DATE") }));

          return false;
        } else if (element.scheduledStart === "") {
          setOpenAlert(true);
          setAlertTitle(t("INVALID_FORM_TITLE"));
          setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("START_TIME") }));

          return false;
        } else if (element.levelByStudent === "") {
          setOpenAlert(true);
          setAlertTitle(t("INVALID_FORM_TITLE"));
          setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("LEVEL_BY_STUDENT") }));

          return false;
        } else return true;
      } else {
        if (
          moment(element.scheduledDate + "T" + element.scheduledStart).isBefore(
            moment(dataNew).format("YYYY-MM-DD HH:mm:ss"),
          ) &&
          !element.disabledEdit
        ) {
          setOpenAlert(true);
          setAlertTitle(t("INVALID_FORM_TITLE"));
          setAlertDescription(t("VALIDATE_SCHEDULE_DATE_PAST"));

          return false;
        }
      }
    }

    if (name.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("NAME") }));

      return false;
    } else if (!/^\S+@\S+\.\S+$/.test(email) || email.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("EMAIL") }));

      return false;
    } else if (nativeLanguageId === undefined) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("NATIVE_LANGUAGE") }));

      return false;
    } else if (countryId.value === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("COUNTRY") }));

      return false;
    } else if (timezone.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("TIMEZONE") }));

      return false;
    } else if (address === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("ADDRESS") }));

      return false;
    } else if (demoClassPhones.length === 0 || demoClassPhones[0].phone.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("CELLPHONE") }));

      return false;
    } else if (demoClassPhones.length === 0 || demoClassPhones[0].userPhoneTypeId === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("TYPE") }));

      return false;
    } else {
      return true;
    }
  };

  const submitHandle = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const submitObj = {};
      commercialResponsibleName && (submitObj.commercialResponsibleName = commercialResponsibleName);
      name && (submitObj.name = name);

      // eslint-disable-next-line
      email && (submitObj.email = email.toLowerCase());
      // email && !/^\S+@\S+\.\S+$/.test(email) && (submitObj.email = email.toLowerCase());

      planId && (submitObj.planId = Number(planId));
      classTool.value && (submitObj.classTool = classTool.value);
      classToolId && (submitObj.classToolId = classToolId);
      companyName && (submitObj.companyName = companyName);
      occupation && (submitObj.occupation = occupation);
      countryId.value && (submitObj.countryId = Number(countryId.value));
      timezone && (submitObj.timezone = timezone);
      nativeLanguageId && (submitObj.nativeLanguageId = Number(nativeLanguageId));
      demoType && (submitObj.demoType = demoType);
      address && (submitObj.address = address);
      submitObj.classConverted = classConverted;
      classConvertedEmail && (submitObj.classConvertedEmail = classConvertedEmail);

      submitObj.demoClassPhones = demoClassPhones.map(({ userPhoneTypeId, phone }) => {
        return { userPhoneTypeId: Number(userPhoneTypeId), phone: phone };
      });
      submitObj.demoClassSchedules = demoClassSchedules?.map(
        ({
          status,
          teacherId,
          levelByLingo,
          scheduledDate,
          affiliateSlug,
          scheduledStart,
          levelByStudent,
          lingoLanguageId,
        }) => {
          const submitDemoClassSchedules = {};
          submitDemoClassSchedules.lingoLanguageId = Number(lingoLanguageId);
          submitDemoClassSchedules.status = status;
          submitDemoClassSchedules.levelByStudent = levelByStudent?.toString() ?? "1";
          affiliateSlug && (submitDemoClassSchedules.affiliateSlug = affiliateSlug);
          scheduledStart &&
            (submitDemoClassSchedules.scheduledStart = moment(`${scheduledDate} ${scheduledStart}`).format(
              "YYYY-MM-DDTHH:mm:ss.sss",
            ));
          levelByLingo && (submitDemoClassSchedules.levelByLingo = levelByLingo);
          teacherId
            ? (submitDemoClassSchedules.teacherId = Number(teacherId))
            : (submitDemoClassSchedules.teacherId = null);
          return submitDemoClassSchedules;
        },
      );
      if (demoClass && demoClass.length > 0) {
        submitObj.id = demoClass[0]?.id;
        submitObj.demoClassSchedules = submitObj?.demoClassSchedules.map((item, index) => {
          return demoClass[0].demoClassSchedules[index]
            ? { ...item, id: demoClass[0]?.demoClassSchedules[index]?.id }
            : { ...item };
        });
      }

      demoClass && demoClass.length > 0
        ? dispatch(editDemoClass(submitObj))
            .then((res) => res.success && navigate(-1))
            .catch((err) => {
              setOpenAlert(true);
              setAlertTitle(t("INVALID_FORM_TITLE"));
              setAlertDescription(err?.response?.data?.error);
            })
        : dispatch(postDemoClass(submitObj))
            .then((res) => res.success && navigate(-1))
            .catch((err) => {
              setOpenAlert(true);
              setAlertTitle(t("INVALID_FORM_TITLE"));
              setAlertDescription(err?.response?.data?.error);
            });
    }
  };

  const addPhone = (e) => {
    e.preventDefault();

    setDemoClassPhones((state) => [...state, { phone: "", userPhoneTypeId: "" }]);
  };

  const removePhone = (e, findIndex) => {
    e.preventDefault();

    setDemoClassPhones(demoClassPhones.filter((value, index) => index !== findIndex));
  };

  const handleChangeList = async (e, index) => {
    e.preventDefault();
    e.persist();

    setDemoClassPhones((state) =>
      state.map((item, i) => (i === index ? { ...item, [e?.target?.name]: e?.target?.value } : item)),
    );
  };

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header title={t("DEMO_CLASS")} icon={classIcon} t={t} />
        <Demos>
          <div className="content">
            <div className="bigBox teste">
              <h2>
                {!demoClass ? t("ADD_NEW") : t("EDIT")} {t("DEMO_CLASS")}
              </h2>

              <div className="planInfo">
                <h3>Plan Information</h3>

                <form className="formulario">
                  <div>
                    <label htmlFor="name">{t("COMERCIAL_RESPONSIBLE")}</label>
                  </div>
                  <input
                    placeholder={t("COMERCIAL_RESPONSIBLE_NAME")}
                    name="commercialResponsibleName"
                    value={commercialResponsibleName}
                    onChange={handleChange}
                  />

                  <h3>{t("PERSONAL_INFORMATION")}</h3>

                  <div>
                    <label htmlFor="name">{t("STUDENT_NAME")}</label>
                    <span className="invalid">{t("REQUIRED_FIELD")}</span>
                  </div>
                  <input placeholder={t("STUDENT_NAME")} name="name" value={name} onChange={handleChange} />

                  <div>
                    <label htmlFor="email">{t("STUDENT_EMAIL")}</label>
                    <span className="invalid">{t("REQUIRED_FIELD")}</span>
                  </div>
                  <input placeholder={t("STUDENT_EMAIL")} name="email" value={email} onChange={handleChange} />

                  <div className="rowSelects">
                    <div>
                      <div>
                        <label htmlFor="language">{t("NATIVE_LANGUAGE")}</label>
                        <span className="invalid">{t("REQUIRED_FIELD")}</span>
                      </div>
                      <div>
                        <select
                          name="nativeLanguageId"
                          onChange={handleChange}
                          value={nativeLanguageId ? nativeLanguageId : ""}
                        >
                          <option value="">{t("SELECT")}</option>
                          {globallanguages?.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div>
                      <div>
                        <label htmlFor="language">{t("DEMO_TYPE")}</label>
                      </div>
                      <div>
                        <select name="demoType" onChange={handleChange} value={demoType}>
                          <option value="">{t("SELECT")}</option>
                          <option value="b2b">B2B</option>
                          <option value="b2c">B2C</option>
                          <option value="b2cbr">B2C BR</option>
                          <option value="partner">Partner</option>
                          <option value="partnerbr">Partner BR</option>
                          <option value="affiliate">Affiliate</option>
                          <option value="affiliatebr">Affiliate BR</option>
                          <option value="interview">Interview</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <InputForLingoPlan name="planId" data={planId} inputChange={handleChange} />

                  <div className="rowSelects">
                    <InputForClassTool name="classTool" data={classTool} inputChange={handleChange} />

                    <div className="classToolIdInput">
                      <label htmlFor="classToolId">{t("TOOL_ID")}</label>
                      <input
                        name="classToolId"
                        onChange={handleChange}
                        className="classToolId"
                        placeholder={t("STUDENT_TOOL_ID")}
                        value={classToolId ? classToolId : ""}
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="companyName">{t("STUDENT_COMPANY")}</label>
                  </div>
                  <input
                    name="companyName"
                    onChange={handleChange}
                    value={companyName ? companyName : ""}
                    placeholder={t("STUDENT_COMPANY_NAME")}
                  />

                  <div>
                    <label htmlFor="occupation">{t("OCCUPATION")}</label>
                  </div>
                  <input
                    name="occupation"
                    onChange={handleChange}
                    value={occupation ? occupation : ""}
                    placeholder={t("STUDENT_OCCUPATION")}
                  />

                  <div className="rowSelectsCountry">
                    <InputForCountry name="countryId" data={countryId} inputChange={handleChange} />
                  </div>

                  <div className="inputs">
                    <div className="lineInputs timezoneCard">
                      <div>
                        <label htmlFor="timezone">{t("TIMEZONE")} </label>
                        <span className="invalid">{t("REQUIRED_FIELD")}</span>
                      </div>
                      <TimezonePicker
                        value={timezone}
                        onChange={(timezoneName) => setTimezone(timezoneName)}
                        inputProps={{ placeholder: "Select Timezone...", name: "timezone" }}
                      />
                    </div>
                    <div className="lineInputs">
                      {/* <p>{t("CURRENT_TIME")}<br /> {t("IN_THIS_TIMEZONE")}: { moment.tz(this.state.timezone).format('LT') }</p> */}
                      <p>
                        {t("CURRENT_TIME")}
                        <br /> {t("IN_THIS_TIMEZONE")}: {dataTimeZone}
                      </p>
                    </div>
                  </div>

                  <div>
                    <label htmlFor="address">{t("ADDRESS")}</label>
                    <span className="invalid">{t("REQUIRED_FIELD")}</span>
                  </div>
                  <input placeholder={t("STUDENT_ADDRESS")} name="address" value={address} onChange={handleChange} />

                  {demoClassPhones?.map((item, index) => {
                    return (
                      <div key={index} className="inputs telefone" style={{ flexDirection: "row" }}>
                        <div className="lineInputs">
                          <div>
                            <label htmlFor={"phone" + index}>{t("TELEPHONE")}</label>
                            <span className="invalid">{t("REQUIRED_FIELD")}</span>
                            {/* {index === 0 && (
                              <span className="invalid">{validations["phone"] && t("REQUIRED_FIELD")}</span>
                            )} */}
                          </div>
                          <input
                            name="phone"
                            value={item.phone}
                            id={"phone" + index}
                            className="inputMobile"
                            required={index === 0}
                            placeholder={t("PHONE_PLACEHOLDER")}
                            onChange={(e) => handleChangeList(e, index)}
                          />
                        </div>
                        <div className="lineInputs">
                          <div>
                            <label htmlFor={"userPhoneTypeId" + index}>{t("TYPE")}</label>
                            <span className="invalid">{t("REQUIRED_FIELD")}</span>
                          </div>
                          <select
                            name="userPhoneTypeId"
                            id={"phoneType" + index}
                            className="inputMobile"
                            value={item.userPhoneTypeId || 15}
                            onChange={(e) => handleChangeList(e, index)}
                          >
                            <option value="">{t("SELECT")}</option>
                            <option value={1}>{t("COMMERCIAL")}</option>
                            <option value={2}>{t("RESIDENCIAL")}</option>
                            <option value={3}>{t("CELLPHONE")}</option>
                            <option value={4}>{t("WHATSAPP")}</option>
                          </select>
                        </div>
                        {index === 0 && (
                          <div className="lineInputs">
                            <SCButtonAddInput name="addphone" onClick={(e) => addPhone(e)}>
                              {t("BTN_ADD_TEL")} +
                            </SCButtonAddInput>
                          </div>
                        )}
                        {index > 0 && (
                          <SCButtonAddInput id={index} name="remove" onClick={(e) => removePhone(e, index)}>
                            {t("DELETE")} <i className="fa fa-times-circle-o fa-lg"></i>
                          </SCButtonAddInput>
                        )}
                      </div>
                    );
                  })}

                  <InputForLingoArray
                    timezone={timezone}
                    addField={addField}
                    name="demoClassSchedules"
                    data={demoClassSchedules}
                    removeField={removeField}
                    showAddLingo={demoClass !== null}
                    nativeLanguageId={nativeLanguageId}
                    childInputChange={childInputChange}
                  />

                  <div className="lineClassConverted">
                    <div>
                      <label>{t("CLASS_CONVERTED")}</label>
                      <div className="switchBox">
                        <div className="switch__container">
                          <input
                            id="switch-shadow"
                            className="switch switch--shadow"
                            name="classConverted"
                            type="checkbox"
                            checked={classConverted}
                            onChange={handleChange}
                          />
                          <label htmlFor="switch-shadow">
                            <span style={{ marginLeft: "50px", fontSize: "12px" }}>
                              {classConverted ? "Yes" : "No"}
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div>
                        <label htmlFor="classConvertedEmail">{t("EMAIL")}</label>
                      </div>
                      <input
                        onChange={handleChange}
                        name="classConvertedEmail"
                        placeholder={t("LINGO_EMAIL")}
                        value={classConvertedEmail ? classConvertedEmail : ""}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="buttons">
              <button onClick={() => navigate(-1)}>
                <i className="fa fa-angle-left" aria-hidden="true"></i>Back
              </button>
              <button onClick={(e) => submitHandle(e)}>Save</button>
            </div>
          </div>

          <Dialog
            open={openAlert}
            onClose={() => setOpenAlert(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="boxModal"
          >
            <DialogTitle id="alert-dialog-title">
              <span className="titleModal">{alerttitle}</span>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="pass-dialog-description" className="boxModal">
                <span className="formulario">
                  <span className="description">
                    {alertdescription[0]?.message ? alertdescription[0]?.message : alertdescription}
                  </span>
                </span>
              </DialogContentText>
            </DialogContent>

            <DialogActions>
              <div className="buttons">
                <button onClick={() => setOpenAlert(false)} color="primary" autoFocus>
                  {t("CLOSE")}
                </button>
              </div>
            </DialogActions>
          </Dialog>
        </Demos>
      </section>
    </div>
  );
}

export default DemoClass;
